import { z } from "zod";

export const ENV = z.object({
    VITE_SUPABASE_URL: z.string(),
    VITE_SUPABASE_ANON_KEY: z.string(),
    VITE_WEBSITE_URL: z.string(),
    VITE_SOLVE_ORG_ID: z.preprocess(Number, z.number()),
    VITE_SENTRY_AUTH_TOKEN: z.string(),
    VITE_SENTRY_ORG: z.string(),
    VITE_SENTRY_PROJECT: z.string(),
    VITE_SENTRY_URL: z.string(),
    VITE_SENTRY_DSN: z.string(),
    MODE: z.enum(['development', 'production']),
    DEV: z.boolean(),
    PROD: z.boolean(),
    VITE_BUILD_TIME: z.string().optional(),
    VITE_APP_VERSION: z.string().optional(),
    VITE_MS_CLARITY_PROJECT_ID: z.string(),
    VITE_USER_1_ID: z.uuid().optional(),
}).parse(import.meta.env);
